<template>
  <div class="result-set">
    <div class="errors" v-show="errors.length > 0">
      <div class="alert alert-danger" v-for="(e,idx) in errors" :key="idx">{{e.description}}</div>
    </div>

    <div class="results" v-if="errors.length === 0">

      <div class="row">

        <div class="col-6 col-xl-12">
          <div class="row">

            <div class="col-sm-12 col-xl-4">
              <h4 class="result-title">Max Hit</h4>
            </div>
            <div class="col-sm-12 col-xl-4"><h4 class="result-title">Accuracy</h4></div>
            <div class="col-sm-12 col-xl-4"><h4 class="result-title">DPS</h4></div>

          </div>
        </div>

        <div class="col-6 col-xl-12">
          <div class="row">
            <div class="col-sm-12 col-xl-4">
              <div class="hitsplat" v-for="mh in calcMaxHit.maxHits()">
                <span class="result-value">{{mh}}</span>
              </div>
            </div>

            <div class="col-sm-12 col-xl-4">
          <span class="result-value" v-b-tooltip.hover.bottom
                :title="calcAccuracy.hitChance()">{{accuracy}}</span>
            </div>

            <div class="col-sm-12 col-xl-4">
          <span class="result-value" v-b-tooltip.hover.bottom
                :title="dps">{{dps.toFixed(3)}}</span>
            </div>
          </div>
        </div>


        <div class="col-6 col-xl-12">
          <div class="row">

            <div class="col-sm-12 col-xl-4">
              <h4 class="result-title">Special Attack Max Hit</h4>
            </div>
            <div class="col-sm-12 col-xl-4"><h4 class="result-title">Prayer Drain</h4></div>
            <div class="col-sm-12 col-xl-4"><h4 class="result-title">Average Kill Time</h4></div>

          </div>
        </div>

        <div class="col-6 col-xl-12">
          <div class="row">
            <div class="col-sm-12 col-xl-4">
              <h3 class="text-white">Coming Soon!</h3>
              <!--              <div class="hitsplat">-->
              <!--                <span class="result-value">{{defensiveMaxHit}}</span>-->
              <!--              </div>-->
            </div>

            <div class="col-sm-12 col-xl-4">
          <span class="result-value" v-b-tooltip.hover.bottom
                :title="`${timePerPrayerPoint} / prayer point`">{{prayerDrain}}</span>
            </div>

            <div class="col-sm-12 col-xl-4">
          <span class="result-value" v-b-tooltip.hover.bottom
                :title="dps">{{averageKillTime}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <NerdResults v-if="showNerd && this.player !== null && this.monster !== null" :monster="monster" :player="player"
                 :setup="setup"></NerdResults>
  </div>
</template>

<script>
  import moment from "moment";
  import {Potions} from "../js/potions.js"
  import {Monster} from "../js/monster"
  import {Damage} from "../js/damage";
  import {Accuracy} from "../js/accuracy";
  import {Player} from "../js/player";
  import NerdResults from "./NerdResults";

  export default {
    name: "ResultSet",
    components: {NerdResults},
    props: {
      setup: {
        type: Object,
      },
      player: {
        type: Object
      },
      monster: {
        type: Object,
      }
    },
    data() {
      return {
        showNerd: false, //Show nerd stats
        calcs: {
          monster: null,
          potion: null,
          maxhit: null,
          accuracy: null,
          player: null,
        },
        weaponTypes: {
          unarmed: 'melee',
          axes: 'melee',
          blunt_weapons: 'melee',
          bulwarks: 'melee',
          claws: 'melee',
          polearms: 'melee',
          pickaxes: 'melee',
          scythes: 'melee',
          slashing_swords: 'melee',
          spears: 'melee',
          spiked_weapons: 'melee',
          stabbing_swords: 'melee',
          'two-handed_swords': 'melee',
          whips: 'melee',
          guns: 'melee',
          polestaves: 'melee',
          salamanders: 'melee',
          //TODO Handle salamanders (all 3 styles)

          //ranged
          bows: 'ranged',
          chinchompas: 'ranged',
          crossbows: 'ranged',
          thrown_weapons: 'ranged',

          //magic
          staves: 'melee',
          bladed_staves: 'melee',
          powered_staves: 'melee',
          'trident-class_weapons': 'magic',
        }
      }
    },
    computed: {
      calcMaxHit: function () {
        return new Damage(this.player, this.setup, this.monster);
        // return this.calcs.maxhit;
      },
      calcAccuracy: function () {
        return new Accuracy(this.player, this.setup, this.monster);
        // return this.calcs.accuracy;
      },
      calcPotion: function () {
        return new Potions(this.player, this.setup);
        // return this.calcs.potion;
      },
      calcPlayer: function () {
        return new Player(this.player, this.setup);
      },
      mh: function () {
        return this.calcMaxHit.maxHits();
      },
      //TODO remove player/setup
      calcMonster: function () {
        return new Monster(this.monster, this.setup, this.player);
      },
      boosts: function () {
        return {
          attack: this.calcPotion.activeAttackBoost(),
          strength: this.calcPotion.activeStrengthBoost(),
          ranged: this.calcPotion.activeRangeBoost(),
          magic: this.calcPotion.activeMagicBoost(),
        }
      },
      errors: function () {
        let errors = [];

        if (this.setup.activeStance === null) {
          errors.push({name: 'no-stance', description: 'No Stance selected'})
        }

        if (this.monster === null) {
          errors.push({name: 'no-monster', description: 'No Monster selected'})
        }

        // if (this.player.hasOwnProperty('isDefault')) {
        //   errors.push({name: 'no-player', description: 'No Player selected'})
        // }

        return errors
      },

      //Time until prayer is drained to 0
      prayerDrain: function () {
        let totalDrain = this.calcPlayer.prayerDrain();
        let prayerBonus = this.calcPlayer.equipBonus().prayer;
        // let usageMin = 60 / ((60 + prayerBonus * 2) / totalDrain * 0.6);
        let pointUsage = (60 + prayerBonus * 2) / totalDrain * 0.6; //Time taken to use 1 prayer point
        let seconds = this.calcPlayer.getLevel('prayer') * pointUsage.toFixed(2);

        return moment().startOf('day').seconds(seconds).format("mm:ss")
      },

      timePerPrayerPoint: function () {
        let totalDrain = this.calcPlayer.prayerDrain();
        let prayerBonus = this.calcPlayer.equipBonus().prayer;
        let pointUsage = (60 + prayerBonus * 2) / totalDrain * 0.6; //Time taken to use 1 prayer point

        return moment().startOf('day').seconds(pointUsage).format("mm:ss")
      },

      //Returns the monsters maximum hit
      defensiveMaxHit: function () {
        return 0 //TODO
      },

      averageKillTime: function () {
        let rawkt = this.monster.hitpoints / this.dps;

        return moment().startOf('day').seconds(rawkt).format("mm:ss")
      },

      maxHit: function () {
        // let mh = new Damage(this.player, this.setup, this.monster);
        return this.calcMaxHit.maxHit();
      },

      /**
       * WIP Max Magic
       * TODO: bolt + chaos gauntlets
       * TODO: god + charge?
       * TODO: magic dart
       */

      dps: function () {
        return this.calcAccuracy.hitChance() * this.calcMaxHit.maxHitModifiers() / this.calcPlayer.attackInterval();
      },

      accuracy: function () {
        return this.calcAccuracy.accuracy();
      },

      salveBonus: function () {
        let m = new Monster(this.monster, this.setup);
        this.calcPlayer.salveBonus(m)
      }
    },
    methods: {
      /**
       * WEAPON BOOSTS BELOW
       */
      //TODO Defence (torags set bonus)
      //TODO Craws's/Viggora's
      //TODO Obsidian armor
      //TODO Crystal armour
      //TODO Konar's blessing
      //TODO Chinchompa
      //TODO Inquisitor's set effect


      /**
       * WEAPON BOOSTS END
       */
    }
  }
</script>

<style scoped>
  .result-title {
    margin-bottom: 0;
    line-height: 60px;
  }

  .result-value {
    color: white;
    font-size: 2rem;
    line-height: 60px;
    text-shadow: 0.1rem 0.1rem black;
  }
</style>



// WEBPACK FOOTER //
// src/components/ResultSet.vue